import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import pluralize from 'pluralize';
import XDate from 'xdate';
import { withStyleSheet } from 'hoc/styles';
import { ActionButton } from 'components/ActionButton';
import { LoaderLogo } from 'components/LoaderLogo';
import { Table } from 'components/Table';
import { Td } from 'components/Td';
import { Text } from 'components/Text';
import { Tr } from 'components/Tr';
import { get } from 'utils';
import { styleSheet } from './stylesheet';

const RESULT_TYPE = 'searchResults';

class ConferenceResults extends PureComponent {
    static propTypes = {
        enabled: PropTypes.bool.isRequired,
        hasMoreResults: PropTypes.bool.isRequired,
        highlightedResult: PropTypes.objectOf(PropTypes.any),
        highlightResult: PropTypes.func.isRequired,
        indexElement: PropTypes.func.isRequired,
        loading: PropTypes.bool.isRequired,
        loadingMoreResults: PropTypes.bool.isRequired,
        loadMoreResults: PropTypes.func.isRequired,
        onClickResult: PropTypes.func.isRequired,
        results: PropTypes.arrayOf(PropTypes.any).isRequired,
        styles: PropTypes.objectOf(PropTypes.any).isRequired
    };

    static defaultProps = {
        highlightedResult: null
    };

    render() {
        const {
            styles,
            enabled,
            results,
            loading,
            loadingMoreResults,
            loadMoreResults,
            hasMoreResults,
            highlightResult,
            highlightedResult,
            indexElement,
            onClickResult
        } = this.props;
        if (!enabled) {
            return null;
        }

        const highlightedType = get(highlightedResult, 'type');

        return (
            <Table styles={styles.results}>
                {loading ? (
                    <Tr>
                        <Td styles={styles.loaderCell} colSpan={2}>
                            <LoaderLogo />
                        </Td>
                    </Tr>
                ) : (
                    results.map((conference, index) => {
                        const { endDate, eventGroupId, eventGroupTitle, startDate, numEvents } = conference;
                        const resultStyles =
                            RESULT_TYPE === get(highlightedResult, 'type') && index === get(highlightedResult, 'index')
                                ? styles.resultHighlighted
                                : styles.result;
                        const startString = new XDate(startDate).toString('MM/dd/yyyy');
                        const endString = new XDate(endDate).toString('MM/dd/yyyy');
                        const dateString = startString === endString ? startString : `${startString} – ${endString}`;
                        return (
                            <Tr
                                elementRef={node => indexElement(RESULT_TYPE, index, node)}
                                key={`conference-${eventGroupId}`}
                                styles={resultStyles}
                                onClick={onClickResult}
                                onMouseEnter={() => {
                                    highlightResult(RESULT_TYPE, index);
                                }}
                            >
                                <Td>
                                    <Text size={2} styles={styles.title}>
                                        {eventGroupTitle}
                                    </Text>
                                    <Text size={0} styles={styles.eventDateTime}>
                                        {`${dateString} • ${pluralize('Presentation', numEvents, true)}`}
                                    </Text>
                                </Td>
                            </Tr>
                        );
                    })
                )}
                {!loading && loadingMoreResults && (
                    <Tr>
                        <Td styles={styles.loadingMore} colSpan={2}>
                            <LoaderLogo />
                        </Td>
                    </Tr>
                )}
                {!loading && !loadingMoreResults && hasMoreResults && (
                    <Tr styles={styles.loadButtonRow} elementRef={node => indexElement('loadMoreButton', 0, node)}>
                        <Td colSpan={2}>
                            <ActionButton
                                onClick={loadMoreResults}
                                styles={
                                    highlightedType === 'loadMoreButton'
                                        ? styles.loadMoreButtonHighlighted
                                        : styles.loadMoreButton
                                }
                            >
                                <Text size={1}>Load More</Text>
                            </ActionButton>
                        </Td>
                    </Tr>
                )}
            </Table>
        );
    }
}

export const ConferenceResultsUI = compose(withStyleSheet(styleSheet))(ConferenceResults);
